import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ListGroup, ListGroupItemProps } from 'react-bootstrap';
import { formatPrice } from '../../utils/utils';

export type customGenericListItemProps = ListGroupItemProps &
  React.PropsWithChildren<{
    withoutBorder?: boolean;
    hasDot?: boolean;
    price?: number;
  }>;

const GenericListItem = ({
  withoutBorder,
  hasDot,
  price,
  children,
}: customGenericListItemProps) => {
  return (
    <ListGroup.Item className={withoutBorder ? 'border-none' : ''}>
      {hasDot && (
        <span className="list-group-item-dot">
          <FontAwesomeIcon color="red" fill="red" icon={light('circle')} />
        </span>
      )}
      {children}
      {price !== undefined && <span className="list-group-item-price">{formatPrice(price)}</span>}
    </ListGroup.Item>
  );
};

export default GenericListItem;
